import { NBPConfig } from '@bo-client/shared/config.model';
import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { UiAdaptionsModel } from '@bo-client/tenant-management/models/ui-adaptions.model';

/** Alles, wovon die Erreichbarkeit eines Status für den aktuellen Mandanten abhängt. */
export interface StatusAvailabilityContext {
  config: NBPConfig;
  uiAdaptions: UiAdaptionsModel[];
  tenant: TenantDto | null;
}

/**
 * Freischaltbedingung eines Status der Blacklist: `true`, wenn der Mandant den Status über einen
 * Prozessschritt erreicht. `null` heißt: kein Prozessschritt erreicht den Status, er ist bei
 * aktiver Konfig nie auswählbar.
 */
export type StatusUnlockCondition = ((ctx: StatusAvailabilityContext) => boolean) | null;

/**
 * Regeln eines Moduls. Status, die nicht in `blacklist` stehen, sind dauerhaft aktiv und immer
 * auswählbar.
 */
export interface StatusRuleSet {
  blacklist: Record<string, StatusUnlockCondition>;
}

/**
 * UI-Adaption aktiv im Sinne der zugehörigen Aktion: nur `visibility === 'show'` zählt, ein fehlender
 * Eintrag heißt ausgeblendet (wie in `order-request-detail(-v2).component.ts`).
 */
export function isUiAdaptionShown(ctx: StatusAvailabilityContext, anchor: string): boolean {
  return ctx.uiAdaptions.some((adaption) => adaption.anchor === anchor && adaption.visibility === 'show');
}
